export function OldIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M2 5a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM5 8a3 3 0 00-3 3v2a3 3 0 106 0v-2a3 3 0 00-3-3zm-1 3a1 1 0 112 0v2a1 1 0 11-2 0v-2zM3 18a1 1 0 100 2h18a1 1 0 100-2H3zM22 12c0-.9-.202-1.66-.596-2.275a3.393 3.393 0 00-1.494-1.262C18.88 8 17.698 8 17.053 8H17a1 1 0 00-1 1v6a1 1 0 001 1h.053c.645 0 1.826.001 2.857-.463a3.393 3.393 0 001.494-1.262C21.798 13.66 22 12.9 22 12zm-2.91-1.713c.276.124.485.29.631.519.147.23.279.595.279 1.194 0 .6-.132.965-.279 1.194a1.398 1.398 0 01-.631.52c-.326.146-.703.218-1.09.253v-3.934c.387.035.764.107 1.09.254zM11 9a1 1 0 10-2 0v6a1 1 0 001 1h4a1 1 0 100-2h-3V9z"
      ></path>
    </svg>
  );
}
